import { createSlice } from '@reduxjs/toolkit';
import { MenuInterface } from '../core/types/menuInterface';


const menuInitialState: Array<MenuInterface> = [];

const menuSlice = createSlice({
      name: 'user',
      initialState: menuInitialState,
      reducers: {
            setMenu: (state, action: any) => {
                  const menu = action.payload;
                  state = menu;
                  return state;
            },

      },
});

export const { setMenu } = menuSlice.actions;

export { menuSlice as MenuSlice };
